import React, { Component } from 'react';

import equals from "fast-deep-equal";

import ThreeD from 'editor/workspace/window/viewer/visual/ThreeD';
import TwoD from 'editor/workspace/window/viewer/visual/TwoD';

import styles from 'editor/workspace/window/viewer/visual/visual.module.scss';

class Visual extends Component {
    revision = 0;

    /**
     * Stops unnecessary rendering from constant mousemoves
     * @param nextProps
     * @param nextState
     * @param nextContext
     * @returns {boolean}
     */
    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const revisionChanged = nextProps.revision !== this.revision;
        const selectionChanged = !equals(nextProps.selection, this.props.selection);
        const tableChanged = !equals(nextProps.table, this.props.table);

        const should = revisionChanged || selectionChanged || tableChanged;
        if (should) this.revision = nextProps.revision;
        return should;
    }

    render() {
        return (
            <div className={styles.visual}>
                {this.props.table.dimension <= 2 ?
                    <TwoD table={this.props.table} uploaded={this.props.uploaded} selection={this.props.selection} updateValue={this.props.updateValue} save={this.props.save} height="255px" />
                    :
                    <ThreeD table={this.props.table} selection={this.props.selection} revision={this.props.revision} />
                }
            </div>
        )        
    }
}

export default Visual;
